// Billing works on calendar months in UTC, so the uptime card does too.
export const currentUtcMonth = (now = new Date()) => {
  const start = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1));
  const end = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() + 1, 1));
  return { start: toUtcString(start), end: toUtcString(end) };
};

const toUtcString = (date) => date.toISOString().replace(".000Z", "Z");

const roundToOneDecimal = (value) => Math.round(value * 10) / 10;

export const uptimeSummary = (uptime) => {
  if (!uptime || !uptime.periodSeconds) {
    return null;
  }
  return {
    hours: roundToOneDecimal(uptime.connectedSeconds / 3600),
    percent: roundToOneDecimal((100 * uptime.connectedSeconds) / uptime.periodSeconds),
    thresholdHours: roundToOneDecimal(uptime.billingThresholdSeconds / 3600),
    thresholdPercent: roundToOneDecimal((100 * uptime.billingThresholdSeconds) / uptime.periodSeconds),
    reached: uptime.billingThresholdReached,
  };
};
